import React from 'react';

import MuiRadioGroup, {
  RadioGroupProps as MuiRadioGroupProps,
} from '@mui/material/RadioGroup';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const RadioGroup = withCoreProps<RadioGroupProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<RadioGroupProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiRadioGroup {...props} className={clsxClass}>
        {children}
      </MuiRadioGroup>
    );
  },
);

export interface RadioGroupProps extends MuiRadioGroupProps, CoreProps {}
